import { API_BASE_URL } from './client';
import { appendTimeRangeToParams } from '../../utils/timeRange';

async function authFetch(keycloak, path) {
  if (!keycloak?.authenticated) {
    throw new Error('User is not authenticated');
  }
  const response = await fetch(`${API_BASE_URL}${path}`, {
    headers: { Authorization: `Bearer ${keycloak.token}` },
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `HTTP ${response.status}`);
  }
  return response;
}

function buildParams({ period, timeRange, showAll = false } = {}) {
  const params = new URLSearchParams();
  if (timeRange) {
    appendTimeRangeToParams(params, timeRange);
  } else {
    params.set('period', period || 'last7days');
  }
  if (showAll) params.append('show_all', 'true');
  return params;
}

export const getAudienceSummary = async (keycloak, {
  period = 'last7days',
  timeRange = null,
  showAll = false,
} = {}) => {
  const params = buildParams({ period, timeRange, showAll });
  const res = await authFetch(keycloak, `/statistics/audience/summary?${params}`);
  return res.json();
};

export const getAudienceTimeseries = async (keycloak, {
  period = 'last7days',
  timeRange = null,
  showAll = false,
} = {}) => {
  const params = buildParams({ period, timeRange, showAll });
  const res = await authFetch(keycloak, `/statistics/audience/timeseries?${params}`);
  return res.json();
};
